import { Button, useForm } from '@dansk-metal/ui';

import { EventDto } from '@web/services/crm-api/rest';

import styles from './event-cancellation-form.module.scss';

export type EventCancellationFormProps = {
	onSubmit: () => void;
	event: EventDto;
};

export function EventCancellationForm({ onSubmit, event }: EventCancellationFormProps) {
	const form = useForm();

	return (
		<form className={styles.container} onSubmit={form.handleSubmit(onSubmit)}>
			<div className={styles.head}>
				<h2>Afmelding</h2>
			</div>

			<div className={styles.block}>
				<h3>Bekræft afmelding</h3>
				<div className={styles.question}>
					Er du sikker på at du vil afmelde dig arrangementet
					“{event.title}”? Denne handling kan ikke fortrydes.
				</div>
			</div>
			<div className={styles.submit}>
				<Button icon={{ icon: 'arrow-right', size: 24 }} type='submit'>
					Afmeld
				</Button>
			</div>
		</form>
	);
}
